import React from "react";

import Chart from "react-apexcharts";

import { barChartConfig, CHART_COLORS } from "../../../utils/chartConfigs";
import EmptyState from "../shared/EmptyState";

/**
 * Simple single-colour bar chart for support ticket volume.
 *
 * @param {{
 *   data: number[],
 *   categories: string[],
 *   height?: number
 * }} props
 */
const TicketVolumeChart = ({ data, categories, height }) => {
  if (!data || data.length === 0) {
    return <EmptyState message="No ticket data available" />;
  }

  const series = [{ name: "Tickets", data }];

  const config = barChartConfig(series, categories, {
    colors: [CHART_COLORS.purple],
  });

  // Override Y-axis formatter to plain numbers (not currency)
  config.yaxis = {
    ...config.yaxis,
    labels: {
      ...config.yaxis?.labels,
      formatter: (val) => {
        if (val >= 1_000) return `${(val / 1_000).toFixed(1)}k`;

        return String(val);
      },
    },
  };

  // Override data-label formatter to plain numbers
  config.dataLabels = {
    ...config.dataLabels,
    formatter: (val) => {
      if (val >= 1_000) return `${(val / 1_000).toFixed(1)}k`;

      return val;
    },
  };

  // Override tooltip formatter to plain numbers
  config.tooltip = {
    ...config.tooltip,
    y: {
      formatter: (val) => `${Number(val).toLocaleString()} tickets`,
    },
  };

  // Separate series from options
  const { series: _series, ...options } = config;

  return (
    <Chart
      height={height || 350}
      options={options}
      series={series}
      type="bar"
    />
  );
};

export default TicketVolumeChart;
